import type { ComponentProps } from "react";

import { cn } from "shared/utils/cn";

export const Title = ({ className, ...props }: ComponentProps<"h1">) => {
  return (
    <h1
      className={cn(
        "flex text-[26px] leading-6 font-semibold tracking-[0.45px]",
        className
      )}
      {...props}
    />
  );
};
